<template>
  <v-card>
    <v-card-title primary-title>
      <div class="headline">{{labels.claimants}}</div>
    </v-card-title>
    <v-card-text>
      <v-card>
        <v-expansion-panel v-if="claimants.length > 0" class="elevation-0">
          <v-expansion-panel-content v-for="(claimant,i) in claimants" :key="i">
            <div slot="header">
              <div class="body-2">
                Claimant No. {{claimant.clmtNo}} - {{claimant.clmtName}}
              </div>
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid infoPadding>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.clmtSalutation}}</v-subheader>
                      <div>{{claimant.clmtSalutation}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.clmtName}}</v-subheader>
                      <div>{{claimant.clmtName}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.clmtDob}}</v-subheader>
                      <div>{{formatDate(claimant.clmtDob)}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.clmtNricPassport}}</v-subheader>
                      <div>{{claimant.clmtIcno}}</div>
                    </v-flex>
                    <v-flex xs12 style="padding-top:10px;padding-bottom:10px">
                      <v-divider/>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.clmtEmail}}</v-subheader>
                      <div v-if="claimant.clmtEmail">{{claimant.clmtEmail}}</div>
                      <div v-else>-</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.clmtMobileNo}}</v-subheader>
                      <div v-if="claimant.clmtMobile">{{claimant.clmtMobile}}</div>
                      <div v-else>-</div>
                    </v-flex>
                    <v-flex xs12>
                      <v-subheader class="queryLabel">{{labels.clmtMailAdd}}</v-subheader>
                      <div v-if="claimant.clmtPostalCode">
                        {{claimant.clmtAddr1}} {{claimant.clmtAddr2}} <span v-if="claimant.clmtAddr3">#{{claimant.clmtAddr3}}</span> {{claimant.clmtAddr4}}, Singapore {{claimant.clmtPostalCode}}
                      </div>
                      <div v-else>-</div>
                    </v-flex>
                    <v-flex xs12 style="padding-top:10px;padding-bottom:10px">
                      <v-divider/>
                    </v-flex>
                    <v-flex xs12>
                      <v-subheader class="queryLabel">{{labels.paytMeth}}</v-subheader>
                      <div v-if="claimant.paytMeth">{{labels.paytMethMap[claimant.paytMeth]}}</div>
                      <div v-else>-</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel" v-if="claimant.payeeBank">{{labels.payeeBank}}</v-subheader>
                      <div>{{claimant.payeeBank}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel" v-if="claimant.payeeAcct">{{labels.payeeAcct}}</v-subheader>
                      <div>{{claimant.payeeAcct}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel" v-if="claimant.acctHoldName">{{labels.acctHoldName}}</v-subheader>
                      <div>{{claimant.acctHoldName}}</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-card-text v-else>
          No Claimant Details Available
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="secondary" @click="doClose">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'

export default {
  props: {
    clmSub: Object
  },
  data() {
    return {
      labels: {
        claimants: 'Claimants',
        clmtSalutation: 'Salutation',
        clmtName: 'Name as in NRIC/Passport',
        clmtNricPassport: 'NRIC/Passport',
        clmtDob: 'Date of Birth',
        clmtMailAdd: 'Mailing Address',
        clmtEmail: 'Email',
        clmtMobileNo: 'Mobile No.',
        paytMeth: 'Payment Method',
        paytMethMap: {
          'C': 'Cheque',
          'I': 'Interbank Transfer'
        },
        payeeBank: 'Name of Bank',
        payeeAcct: 'Payee\'s Bank Account No',
        acctHoldName: 'Account Holder Name'
      }
    }
  },
  methods: {
    doClose() {
      this.$emit('doClose')
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(Number(xNum))
    }
  },
  computed: {
    claimants() {
      return this.clmSub.clmtDetStgs
    }
  }
}
</script>

<style>
.infoPadding {
  padding: 10px;
}
.reservePadding {
  padding-left: 18px;
}
</style>
